<template>
  <section class="logist">
    <div class="logist__header">
      <h2 class="logist__header-title">Статистика погрузок логиста</h2>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-date-picker
            v-model="form.stat_date_from"
            :picker-options="startPickerOptions"
            format="dd/MM/yyyy"
            value-format="timestamp"
            clear-icon="false"
            placeholder="Дата с"
            @change="form.stat_date_to = ''"
          />
        </el-col>
        <el-col :span="12">
          <el-date-picker
            v-model="form.stat_date_to"
            :picker-options="finishPickerOptions"
            :disabled="!form.stat_date_from"
            format="dd/MM/yyyy"
            value-format="timestamp"
            clear-icon="false"
            placeholder="Дата по"
          />
        </el-col>
      </el-row>
      <el-button
        type="primary"
        round
        :disabled="isDisabled"
        :loading="loading"
        class="logist__header-button"
        @click.prevent="getLogistStatistic"
      >
        Сформировать
      </el-button>
    </div>
    <transition name="el-fade-in-linear">
      <div v-if="Array.isArray(statistic)">
        <div v-if="statistic.length" class="logist__report">
          <div class="logist__report-header">
            <div class="title">Записал</div>
            <div class="title">Выгруз.</div>
            <div class="title">Удалено</div>
          </div>
          <el-table :data="statistic" border :row-class-name="rowClassName">
            <el-table-column prop="name" class-name="name" />
            <el-table-column prop="created" width="55" align="right" />
            <el-table-column prop="unloaded" width="55" align="right" />
            <el-table-column prop="deleted" width="55" align="right" />
          </el-table>
        </div>
        <div v-else class="logist__nothing">нет данных за указанный период</div>
      </div>
    </transition>
  </section>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'

const RespAPI = RepositoryFactory.get('responses')

export default {
  name: 'StatisticByLogist',
  data() {
    return {
      form: {
        stat_date_from: '',
        stat_date_to: '',
      },
      statistic: null,
      loading: false,
      startPickerOptions: {
        firstDayOfWeek: 1,
      },
      finishPickerOptions: {
        firstDayOfWeek: 1,
        disabledDate: time => time < this.form.stat_date_from,
      },
    }
  },
  computed: {
    isDisabled() {
      return !this.form.stat_date_from || !this.form.stat_date_to
    },
  },
  methods: {
    getLogistStatistic() {
      this.loading = true
      const params = {
        user_id: this.userInfo.id,
        from: this.form.stat_date_from / 1000,
        // добавляем сутки, чтобы получить конец дня
        to: this.form.stat_date_to / 1000 + 86400,
      }

      RespAPI.getStatisticByLogist(params)
        .then(res => {
          this.statistic = []
          res.data.forEach(group => {
            this.statistic.push({
              name: group.title,
              created: group.total_created,
              unloaded: group.total_unloaded,
              deleted: group.total_deleted,
              isTitle: true,
            })

            group.members.forEach(logist => this.statistic.push(logist))
          })
        })
        .catch(err => this.errHandler(err))
        .finally(() => (this.loading = false))
    },
    rowClassName({ row }) {
      return row.isTitle ? 'headerRow' : 'itemRow'
    },
  },
}
</script>

<style lang="sass" scoped>
.logist
  margin-top: 10px
  margin-left: 20px
  padding: 5px 15px 20px
  color: #303133
  background: #fff
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
  border-radius: 4px
  &__header
    text-align: center
    &-title
      margin-bottom: 10px
    &-button
      margin-top: 10px

  &__nothing
    margin-top: 15px
    font-size: 14px
    font-style: italic
    text-align: center

  &__report
    margin-top: 16px
    &-header
      display: flex
      justify-content: flex-end
      .title
        width: 56px
        height: 20px
        line-height: 20px
        border-top: 2px solid #606266
        border-right: 2px solid #606266
        text-align: center
        font-size: 10px
        font-weight: 500
        &:first-of-type
          border-left: 2px solid #606266

  .el-table
    min-height: unset
    border-left: 2px solid #606266
    border-right: 2px solid #606266
    border-bottom: 2px solid #606266
    border-top: 1px solid #606266
    border-radius: 4px 0 4px 4px
    color: #303133

  .el-table--border::after
    display: none
  .el-table::before
    display: none

  .el-table ::v-deep .headerRow
    background: #ccc
    font-weight: 500
    td
      border-top: 1px solid #606266
  .el-table ::v-deep .itemRow
    color: #606266

  .el-table ::v-deep tr
    td
      border-right: 1px solid #606266
      border-bottom: 1px solid #606266
      &:last-child
        border-right: none
    &:last-child
      td
        border-bottom: none

  .el-table ::v-deep .name .cell
    white-space: nowrap
</style>
